import React, { useMemo } from 'react'
import styled from 'styled-components'

import { useGetCustomerRewardsOrders } from '../../../../../lib/orders/hooks/useGetCustomerRewardsOrders'
import { RewardsSourceConfig } from '../../../../../lib/rewards/sources'
import { isNotNull } from '../../../../../utils/collectionTools'
import Link from '../../../../global/Link'
import Spinner from '../../../../Spinner'
import EmptyOrderHistory from '../../orders/EmptyOrderHistory'
import { CustomerRewardsOrdersTable } from '../../orders/table'
import QueryFallback from '../../QueryFallback'

export interface RecentRewardsOrdersContainerProps {
  rewardsSource: RewardsSourceConfig
}

const StyledMostRecentOrders = styled.div`
  margin-bottom: 17px;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  a {
    font-size: 14px;
    text-align: end;
    color: ${({ theme }) => theme.colors.brand.red};
  }
  h3 {
    margin-bottom: 0;
  }
`

const RecentRewardsOrdersContainer: React.FC<RecentRewardsOrdersContainerProps> = ({
  rewardsSource,
}) => {
  const { name, slug, filter } = rewardsSource
  const { data, error, refetch, loading } = useGetCustomerRewardsOrders({ filter })
  const orders = useMemo(
    () => data?.getCustomerRewardsOrders?.orders?.filter(isNotNull),
    [data?.getCustomerRewardsOrders?.orders],
  )
  const anyOrdersPresent = !!orders?.length

  if (loading) {
    return <Spinner loading />
  }

  return (
    <>
      <StyledMostRecentOrders>
        <h3>Most Recent {name} Orders</h3>
        <Link to={`/account/rewards/orders/${slug}`}>View all orders</Link>
      </StyledMostRecentOrders>
      {!!error && !loading && <QueryFallback error={error} onRetry={() => refetch()} />}
      {orders && anyOrdersPresent ? (
        <CustomerRewardsOrdersTable orders={orders} urlFragment={`rewards/orders/${slug}`} />
      ) : (
        <EmptyOrderHistory />
      )}
    </>
  )
}

export default RecentRewardsOrdersContainer
